import { hpxConfig } from 'shared/config/hpx_config';
import { iceCstlConfig } from 'shared/config/icecstl_config';
import { baseConfig } from 'shared/config/base_config';
import { getUrlParam } from 'shared/utils/Helpers';
import { mobileCartConfig } from './mobilecart_config';

let domains = window.location.hostname.match(/([a-z0-9]*)\.capturelife\.com/);

let subdomain = 'local'
try {
  subdomain = domains[1];
} catch {
  // pass
}

let port = window.location.port;
let config = {};

let staging_hpx_ports = ['3008', '3009', '3013'];
let staging_icecstl_ports = ['3010'];
let local_hpx_ports = ['8906', '8907', '8913'];
let local_icecstl_ports = ['8910'];
let webcart_ports = ['3012', '3013', '8912', '8913']; // staging/staging-hpx/local/local-hpx respectively

baseConfig(config);

switch (subdomain) {
  case 'app':
  case 'app2':
  case 'kiosk':
  case 'kiosk2':
  case 'kiosk3':
  case 'clubmed':
  case 'clubmed2':
  case 'clubmed3':
  case 'chukka':
  case 'chukka2':
  case 'chukka3':
  case 'share':
  case 'aegrugby':
  case 'aegrugby2':
  case 'portal':
    config.env = 'production';
    break;
  case 'mlb':
  case 'mlb2':
    config.env = 'production';
    config.mlb = true;
    break;
  case 'cart':
    config.env = 'production';
    mobileCartConfig(config);
    break;
  case 'harrypotterexhibition':
  case 'harrypotterexhibitionkiosk':
    config.env = 'production';
    hpxConfig(config);
    break;
  case 'harrypotterexhibitioncart':
    config.env = 'production';
    mobileCartConfig(config);
    hpxConfig(config);
    break;
  case 'icecastleskiosk':
    config.env = 'production';
    iceCstlConfig(config);
    break;
  case 'staging':
    config.env = 'staging';
    if (webcart_ports.includes(port)) {
      mobileCartConfig(config);
    }

    if (staging_hpx_ports.includes(port)) {
      hpxConfig(config);
    } else if (staging_icecstl_ports.includes(port)) {
      iceCstlConfig(config);
    }
    break;
  case 'dev':
    config.env = 'dev';
    if (port == 8909) {
      hpxConfig(config);
    }
    break;

  case 'local':
    config.env = 'local';

    if (port == '3000') {
      config.env = 'npm-start'
      break;
    }

    if (webcart_ports.includes(port)) {
      mobileCartConfig(config);
    }

    if (local_hpx_ports.includes(port)) {
      hpxConfig(config);
    } else if (local_icecstl_ports.includes(port)) {
      iceCstlConfig(config);
    }
    break;
}

// URL params
// override kiosk auto logout timeout
let timeout = getUrlParam('timeout');
if (timeout) {
  config.kiosk_inactivity_timeout = timeout;
  config.kiosk_auto_logout_countdown = timeout;
}

export default config;
